import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc ActionItemDetailInnerTab defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ActionItemDetailInnerTabService } from 'services/actionItemDetailInnerTab';
 *
 * // create service instance and send/cancel request
 * const actionItemDetailInnerTabService = new ActionItemDetailInnerTabService();
 * const result = await actionItemDetailInnerTabService.fetchData( '<user-id>' ); // fetch data
 * actionItemDetailInnerTabService.cancel(); // cancel an active request
 */
export class ActionItemDetailInnerTabService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
           // extract component data
           const tabsConfig = get( response, 'body.component.structure.tabsConfig', {} );
           const member = get( response, 'body.component.data.state.member', [] );
           
           return {
               status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
               data: {
                   tabs: [
                        {
                            id: member.memberId,
                            patientId: member.patientId,
                            name: tabsConfig.name,
                            url: tabsConfig.url,
                            requestPayload: { memberId: member.memberId,  patientId: member.patientId },
                            title: {
                                refId: '',
                                value: member.name,
                            },
                            action: get( member, 'actionsVisibility.view' ) ? tabsConfig.viewAction : null, // view more action
                        }
                    ]
                }
           };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
